// extracted by mini-css-extract-plugin
export default {"back":"R0djb","close":"XbC5G","signUpBottomScreen":"Ivgjv"};